import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'jquery';
import 'bootstrap';

import '../shared/remove-noscript';
import '../barrierefreiheit/custom';
import '../barrierefreiheit/mainmenu';

import Application from 'plugins/xlib/js/lib/Application';
import NewsletterElement from 'plugins/xlib-reichweiten/js/elements/Newsletter';
import SearchResultsElement from 'plugins/xlib-reichweiten/js/elements/SearchResults';
import HeaderElement from 'plugins/xlib-reichweiten/js/elements/Header';
import NewsletterPluginForm from 'plugins/xlib-reichweiten/js/elements/NewsletterPluginForm';
import ThemeSwitch from 'plugins/xlib-reichweiten/js/elements/ThemeSwitch';

Application.configure({
    Elements: {
        'is-element-newsletter': NewsletterElement,
        'is-element-search-results': SearchResultsElement,
        'is-element-header': HeaderElement,
        'is-element-newsletter-plugin-form': NewsletterPluginForm,
        'is-element-theme-switch': ThemeSwitch
    }
});
Application.start();
